/**
 * Constantes partagées de la page Graphiques (v2).
 */

// Palette bleue brand-aligned (primary = blue-600)
export const BRAND_BLUE = "hsl(221 83% 53%)";  // blue-600
export const BRAND_BLUE_DARK = "hsl(224 76% 33%)"; // blue-800
export const BRAND_BLUE_LIGHT = "hsl(213 94% 68%)"; // blue-400

// Palette dégradée pour segmentation (vendeurs, types, années)
// Couleurs distinguables tout en restant dans la famille brand.
export const SERIES_COLORS = [
  "#1d4ed8", // blue-700
  "#0891b2", // cyan-600
  "#7c3aed", // violet-600
  "#db2777", // pink-600
  "#ea580c", // orange-600
  "#16a34a", // green-600
  "#ca8a04", // yellow-600
  "#0d9488", // teal-600
  "#9333ea", // purple-600
  "#dc2626", // red-600
  "#0284c7", // sky-600
  "#65a30d", // lime-600
];

export const colorFor = (index) => SERIES_COLORS[index % SERIES_COLORS.length];

export const TIME_RANGE_PRESETS = [
  { value: "3months", label: "3 derniers mois" },
  { value: "12months", label: "12 derniers mois" },
  { value: "current_quarter", label: "Trimestre en cours" },
  { value: "current_civil_year", label: "Année civile en cours" },
  { value: "current_fiscal_year", label: "Année comptable en cours" },
  { value: "3years", label: "3 dernières années" },
  { value: "all", label: "Depuis le début" },
  { value: "custom", label: "Personnalisé" },
];

export const SANS_VENDEUR_ID = "__none__";
